﻿<template>
    <!-- in-card message for the login screens (replaces window.alert); see .lg-alert in css/components/login.css -->
    <transition name="lg-alert">
        <div v-if="message != ''" class="lg-alert" :class="'is-' + type" :role="type == 'error' ? 'alert' : 'status'">
            <svg v-if="type == 'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M8 12l3 3 5-6" /></svg>
            <svg v-else-if="type == 'info'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></svg>

            <div class="lg-alert-body">
                <p v-if="title != ''" class="lg-alert-title">{{ title }}</p>
                <p class="lg-alert-text">{{ message }}</p>
            </div>

            <button type="button" class="lg-alert-close" aria-label="Dismiss message" @click="$emit('dismiss')">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" /></svg>
            </button>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: "login_alert",
    props: {
        message: { type: String, default: "" },
        title: { type: String, default: "" },
        type: { type: String as PropType<'error' | 'success' | 'info'>, default: 'error' }
    },
    emits: ["dismiss"]
});
</script>
